var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import OwnerpartySelector from '../../../../components/OwnerpartySelector';
import TemplateFormatSelector from '../../../EditTemplate/components/TemplateFormatSelector';
var SelectorWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  > * {\n    width: 100%;\n  }\n  & > :not(:first-child){\n    padding-left: 1rem;\n  }\n"], ["\n  display: flex;\n  > * {\n    width: 100%;\n  }\n  & > :not(:first-child){\n    padding-left: 1rem;\n  }\n"])));
var FormatAndOwnerpartySelectors = function (_a) {
    var setOwnerpartyKey = _a.setOwnerpartyKey, setFormat = _a.setFormat;
    return _jsxs(SelectorWrapper, { children: [_jsx(TemplateFormatSelector, { onChange: setFormat }), _jsx(OwnerpartySelector, { onChange: setOwnerpartyKey })] });
};
export default FormatAndOwnerpartySelectors;
var templateObject_1;
